import {
  BOARDS_COLLABORATOR_USER,
  BOARDS_COLLABORATOR_GROUP,
} from '../../constants/boards'

const groupAssetsByBoard = (boardAssets = {}, latestAssets = {}) => {
  const modifiedBoardAssets = boardAssets || {}
  const latestAssetsEntries = Object.keys(latestAssets) || []
  if (latestAssetsEntries.length > 0) {
    latestAssetsEntries.forEach((boardId) => {
      const boardAssetsList = latestAssets[boardId]
      modifiedBoardAssets[boardId] = boardAssetsList?.assets
    })
  }
  return modifiedBoardAssets
}

const noOfAssetsInBoard = (boardAssets = {}, board_id = '') =>
  Object.keys(boardAssets).indexOf(board_id) !== -1
    ? boardAssets[board_id].length
    : 0

const structureCollaboratorList = (collaborators = []) => {
  collaborators.forEach((collaborator = {}) => {
    const { login_id = '', display_name = '', list_name = '' } = collaborator
    // if single user
    if (login_id) {
      collaborator.display_name = display_name.indexOf('.')
        ? display_name.split('.').join(' ')
        : display_name
      let displayNameArr = collaborator.display_name.split(' ')
      collaborator.first_name = collaborator.first_name
        ? collaborator.first_name
        : displayNameArr[0] || ''
      collaborator.last_name = collaborator.last_name
        ? collaborator.last_name
        : displayNameArr[1] || ''
      collaborator.type = BOARDS_COLLABORATOR_USER
      collaborator.name = display_name
    } else {
      // if group
      collaborator.type = BOARDS_COLLABORATOR_GROUP
      collaborator.name = list_name
      collaborator.expanded = false
      collaborator.fetchingUsers = false
    }
  })
  return collaborators
}

const getSortDetails = (sortCriteria) => {
  switch (sortCriteria) {
    case 'asset_name_desc':
      return { sortBy: 'fileName', sortOrder: 'desc' }
    case 'asset_name_asc':
      return { sortBy: 'fileName', sortOrder: 'asc' }
    case 'added_date_desc':
      return { sortBy: 'createdDate', sortOrder: 'desc' }
    case 'added_date_asc':
      return { sortBy: 'createdDate', sortOrder: 'asc' }
    case 'asset_uploaded_desc':
      return { sortBy: 'importDate', sortOrder: 'desc' }
    case 'asset_uploaded_asc':
      return { sortBy: 'importDate', sortOrder: 'asc' }
    default:
      return { sortBy: 'createdDate', sortOrder: 'desc' }
  }
}

export { groupAssetsByBoard, noOfAssetsInBoard, structureCollaboratorList, getSortDetails }
